import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { communityFeedApi } from 'src/Services/API';
import { editCommunityFeedItemCache } from 'src/Services/API/cache';

export type DeleteCommunityFeedItemVariables = { feedItemId: string; commentId: string };

export const useDeleteCommunityFeedItemComment = (
  options?: UseMutationOptions<void, unknown, DeleteCommunityFeedItemVariables>
) => {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, DeleteCommunityFeedItemVariables>(
    'delete-community-feed-item-comment',
    async (data: DeleteCommunityFeedItemVariables) => {
      await communityFeedApi.communityFeedControllerRemoveComment(data.feedItemId, data.commentId);
    },
    {
      ...options,
      onSuccess(data, variables, context) {
        editCommunityFeedItemCache(queryClient, feedItem => {
          if (feedItem.id !== variables.feedItemId) return feedItem;

          return {
            ...feedItem,
            comments: {
              ...feedItem.comments,

              // Decrement the comment count
              count: feedItem.comments.count - 1,
            },
          };
        });

        queryClient.invalidateQueries(['fetch-community-feed-item-comments', variables.feedItemId]);

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
